import { apiClient } from '../../gateways/api'
import type { Projectmelding } from '../types/Projectmelding'

export { fetchProjectmelding }

const fetchProjectmelding = async ({
  id,
  projectdossierId,
}: {
  id?: string
  projectdossierId?: string
}): Promise<Projectmelding> => {
  const url = projectdossierId
    ? `/rest/projectdossier/${projectdossierId}/projectmelding`
    : `/rest/projectmelding/${id}`

  const { data } = await apiClient({
    url,
    method: 'GET',
  })

  return data
}
